import { pick, prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import * as server from '../server';
import * as actions from '../store/actions';

export const useGetUserUrlTemplates = () => {
    const dispatch = useDispatch();
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    const { casinoName, clientSkin, clientType, userSegmentURLType } = useAppSelector(pick([
        'casinoName', 'clientSkin', 'clientType', 'userSegmentURLType'
    ]));

    return useCallback(async (urlType) => {
        if (!urlType && !userSegmentURLType) {
            dispatch(actions.userUnsetAttributesAction('urlTemplates'));

            return;
        }

        const response = await server.getURLsRequest({
            urlTypeList: [urlType || userSegmentURLType],
            casinoName, clientSkin, clientType, clientPlatform
        });
        const urlList = response?.data?.urlList;
        // 0 is highest, 10 is lowest
        const highestPriority = urlList
            .map(tmpl => tmpl.priority)
            .reduce((highest, priority) => priority < highest ? priority : highest, Infinity);
        const urlTemplates = urlList
            .filter(tmpl => tmpl.priority <= highestPriority)
            .map(tmpl => tmpl.url);

        dispatch(actions.userSetAttributesAction({ urlTemplates }));

        return urlTemplates;
    }, [casinoName, clientSkin, clientType, clientPlatform, userSegmentURLType, dispatch]);
};
